import React, { useMemo } from 'react';
import { FiAlertCircle, FiMessageSquare } from 'react-icons/fi';
import CollapsibleSideShell from '../drawing-ui/CollapsibleSideShell.jsx';
import CommunicationsRightPanel from './CommunicationsRightPanel.jsx';

export default function CommunicationsRightSidebar({
  tab,
  onTabChange,
  collapsed,
  onCollapse,
  issues,
  activeIssueId,
  onSelectIssue,
  selectedItem,
  allItems,
  activeConflict,
  activeThreadKey,
  alignmentAnswer,
  alignmentLoading,
  onAsk,
  onRecordDecision,
}) {
  const railActions = useMemo(
    () => [
      {
        id: 'issues',
        label: 'Communication issues',
        icon: <FiAlertCircle size={20} />,
        onClick: () => {
          onTabChange('issues');
          onCollapse(false);
        },
      },
      {
        id: 'detail',
        label: 'Message and alignment',
        icon: <FiMessageSquare size={20} />,
        onClick: () => {
          onTabChange('detail');
          onCollapse(false);
        },
      },
    ],
    [onCollapse, onTabChange]
  );

  return (
    <CollapsibleSideShell
      side="right"
      collapsed={collapsed}
      onToggle={() => onCollapse(true)}
      onExpand={() => onCollapse(false)}
      expandedWidth="clamp(300px, 32vw, 420px)"
      railActions={railActions}
      activeRailId={tab}
      persistentRail
      collapseLabel="Collapse communications panel"
    >
      <CommunicationsRightPanel
        tab={tab}
        issues={issues}
        activeIssueId={activeIssueId}
        onSelectIssue={onSelectIssue}
        selectedItem={selectedItem}
        allItems={allItems}
        activeConflict={activeConflict}
        activeThreadKey={activeThreadKey}
        alignmentAnswer={alignmentAnswer}
        alignmentLoading={alignmentLoading}
        onAsk={onAsk}
        onRecordDecision={onRecordDecision}
      />
    </CollapsibleSideShell>
  );
}
